import React, { useEffect, useState, useRef } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Grid, Col } from "react-bootstrap";

import { useInput } from "../../Shared/hooks/useInput";
import { Container } from "./Contact.styles";
import { searchProfiles as searchProfilesAction } from "../../../redux/middleware/profile";
import { getProfiles } from "../../../redux/reducers/profile";
import { createMessage } from "../../../redux/middleware/message";

import ContactForm from "./ContactForm";
import { DocumentViewerNoModal } from "../../Shared";

const ContactApplicant = ({
  searchProfiles,
  profiles,
  slug,
  notify,
  user,
  createNewMessage,
  messages,
}) => {
  useEffect(() => searchProfiles("", "", ""), []);

  const { value: name, bind: bindName, setDefaultValue: setName } = useInput("");
  const { value: company, bind: bindCompany, setDefaultValue: setCompany } = useInput("");
  const { value: message, bind: bindMessage } = useInput("");
  const { value: jobTitle, bind: bindJobTitle, reset: resetJobTitle} = useInput("");
  const { value: jobDescription, bind: bindJobDescription } = useInput("");
  const [shownNotification, setShownNotification] = useState(true);

  const checkProps = useRef(true);
  useEffect(() => {
    if(checkProps.current) {
      checkProps.current = false;
    }
    setName(user && `${user.fname || ""} ${user.lname || ""}`);
    setCompany(user && user.company && user.company.name);
  }, [user])

  const userProfile = profiles.find((profile) => profile.slug === slug);
  const contactCredits = (user && user.contact_credits.length) || 0;

  const handleSubmit = (e) => {
    setShownNotification(false);
    e.preventDefault();
    const data = {
      name,
      company,
      body: message,
      job_title: jobTitle,
      job_description: jobDescription,
      profile_id: userProfile && userProfile.id,
    };
    createNewMessage({ message: data });
    resetJobTitle();
  };

  if (!shownNotification && messages && !messages.pending) {
    if (
      messages.error ||
      (messages.subscriptions &&
        !messages.subscriptions.products.message_object.created_message)
    ) {
      notify(
        "error",
        message.error ||
          messages.subscriptions.products.message_object.message ||
          "Message was not sent"
      );
    } else {
      notify("success", "Email sent successfully");
    }
    setShownNotification(true);
  }

  return (
    <Grid>
      <Container>
        <Col md={7}>
          <DocumentViewerNoModal
            show
            hide={false}
            styles={{ width: "100%", backgroundColor: "#dfe1e4" }}
            content={userProfile && userProfile.resume.content}
          />
        </Col>
        <ContactForm
          name={userProfile && userProfile.user}
          onSubmit={handleSubmit}
          loading={messages && messages.pending}
          credits={contactCredits}
          bind={{
            bindName,
            bindJobTitle,
            bindMessage,
            bindCompany,
            bindJobDescription,
          }}
        />
      </Container>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  profiles: getProfiles(state),
  user: state.userByToken.user,
  messages: state.messages,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      searchProfiles: searchProfilesAction,
      createNewMessage: createMessage,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ContactApplicant));
